<div class="accordion" style="margin-top: 4rem">
  <div
    class="accordion-item"
    *ngFor="let category of categories; let i = index"
  >
    <div
      class="accordion-header"
      (click)="toggleAccordion(i)"
      [class.expanded]="category.expanded"
    >
      <span class="accordion-label">{{ category.TWL_NAME }}</span>
      <span class="accordion-arrow">&#9662;</span>
    </div>

    <div
      class="accordion-panel"
      *ngIf="insiteIndex == i"
    >
          <!-- [@expandCollapse]="category.expanded ? 'expanded' : 'collapsed'" -->

      <ul>
        <li
          *ngFor="let question of questionsByCategory[category.TWL_ID]"
          (click)="onQuestionClick(question, $event)"
          class="question-item"
        >
          <ng-container
            *ngIf="question.QuestionText === 'Get Details of Stock No:'; else defaultText"
          >
            Get Details of Stock No:
            <input
              type="text"
              (click)="$event.stopPropagation()"
              [(ngModel)]="stockNumber"
              placeholder="Enter Stock Number"
              style="margin-right: 10px"
            />
            <button
              style="
                background: #2b5cff;
                color: white;
                border: none;
                padding: 8px 28px;
                border-radius: 20px;
                font-size: 14px;
                cursor: pointer;
              "
              (click)="getStockData(question,stockNumber)"
            >
              Submit
            </button>
          </ng-container>

          <ng-template #defaultText> {{ question.QuestionText }} </ng-template>

          <div
            *ngIf="selectedQuestion === question"
            class="question-answer"
            style="font-size: 0.9rem"
          >
            <div [innerHTML]="selectedQuestion.Answer"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
